import toast from 'react-hot-toast'

import { useMutation, useQueryClient } from '@fv/client-core'

import type { AdminLoad } from '@/types/admin-load'
import { adminFetch } from '@/utils'

async function cancelLoad(dto: { loadId: string }) {
  return adminFetch<AdminLoad>(`/loads/${dto.loadId}/cancel`, {
    method: 'POST',
  })
}

export function useCancelLoad() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: cancelLoad,
    onError: (error: { message: string }) => {
      toast.error(error.message)
    },
    onSuccess: (load: AdminLoad) => {
      queryClient.invalidateQueries({ queryKey: ['dispatch-list'] })
      queryClient.invalidateQueries({ queryKey: ['missing-bol-list'] })
      queryClient.setQueryData(['load', load._id], load)

      if (load.cancel?.status === 'error') {
        toast.error('Load cancellation failed. See cancel details.')
      } else {
        toast.success('Load has been canceled.')
      }
    },
  })
}
